/*=========================================================================================
  File Name: moduleScheduleActions.js
  Description: Schedule Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	addEvent({commit}, event) {
		return new Promise((resolve, reject) => {
			Api.post("/events/create", event)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchEvents({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/api/apps/calendar/events")
				.then((response) => {
					commit("SET_EVENTS", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchEventsByResourceId({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/events/list", payload)
				.then((response) => {
					commit("SET_SCHEDULE_EVENTS", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchEventStatusLabel({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/schedule/status")
				.then((response) => {
					commit("SET_SCHEDULE_LABELS_STATUS", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	editEvent({commit}, event) {
		const eventUpdate = {...event};
		return new Promise((resolve, reject) => {
			Api.post(`/events/reschedule`, eventUpdate)
				.then((response) => {
					// Organization data for update the store information
					eventUpdate["date_prog"] = eventUpdate.date;
					delete eventUpdate.date;
					commit("UPDATE_EVENT", eventUpdate);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeEvent({commit}, event) {
		return new Promise((resolve, reject) => {
			Api.post(`/events/cancel`, event)
				.then((response) => {
					commit("REMOVE_EVENT", event);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	eventDragged({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post(`/api/apps/calendar/event/dragged/${payload.event.id}`, {
				payload,
			})
				.then((response) => {
					// Convert Date String to Date Object
					const event = response.data;
					event.startDate = new Date(event.startDate);
					event.endDate = new Date(event.endDate);

					commit("UPDATE_EVENT", event);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	cleanEvents({commit}) {
		commit("CLEAN_EVENTS");
	},
};
